import { render } from "./ListeFavoris.vue?vue&type=template&id=44a69cf5"
import script from "./ListeFavoris.vue?vue&type=script&lang=js"
export * from "./ListeFavoris.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__